"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSupplyPointSummary = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var SimpleContentCard_1 = require("../SimpleContentCard");
exports.StyledSupplyPointSummary = (0, styled_components_1.default)(SimpleContentCard_1.SimpleContentCard)(function (_a) {
    var colors = _a.theme.colors;
    return "\n    svg[data-icon=\"supply-point\"] {\n      color: ".concat(colors.heading, ";\n    }\n    ");
});
